export const featuredPortfolio = [
    {
      id: 1,
      title: "52 Shades of Red",
      link: "https://www.bilibili.com/video/BV1Zy4y1H7nw",
      img:
        "https://images.squarespace-cdn.com/content/v1/5867e96dc534a51440713a37/1562188707399-ZLIA543J61D8W3FIGKRZ/59923-full.png?format=2500w",
    },
    {
      id: 2,
      title: "Ultimate Cartes Folles",
      link: "https://www.bilibili.com/video/BV1aK4y1d7cE",
      img:
        "https://m.media-amazon.com/images/I/51+w3QHeyCL._AC_SX355_.jpg",
    },
    {
      id: 3,
      title: "Elmsley Count",
      link: "https://www.bilibili.com/video/BV1F34y167KU/",
      img:
        "https://i.ytimg.com/vi/nDj-XpxmN4Q/maxresdefault.jpg",
    },
    {
      id: 4,
      title: "Coin Matrix",
      link: "https://www.bilibili.com/video/BV1Nr4y1U7qw/",
      img:
        "https://i.ytimg.com/vi/Y5hXMFM1s1M/maxresdefault.jpg",
    },
    {
      id: 5,
      title: "The Matrix",
      link: "https://www.bilibili.com/video/BV1Sr4y1v7Qu/",
      img:
        "https://s24193.pcdn.co/wp-content/uploads/2017/06/entity-magic--1320x720.jpg",
    },
    {
      id: 6,
      title: "Happy New Year",
      link: "https://www.bilibili.com/video/BV19S4y1y7Na/",
      img:
        "https://vinc.gumlet.io/gallery/blog/Easy-to-do-card-magic-tricks-637181767004663922.jpg",
    },
  ];
  
  export const cardPortfolio = [
    {
      id: 1,
      title: "52 Shades of Red",
      link: "https://www.bilibili.com/video/BV1Zy4y1H7nw",
      img:
        "https://images.squarespace-cdn.com/content/v1/5867e96dc534a51440713a37/1562188707399-ZLIA543J61D8W3FIGKRZ/59923-full.png?format=2500w",
    },
    {
      id: 2,
      title: "Ultimate Cartes Folles",
      link: "https://www.bilibili.com/video/BV1aK4y1d7cE",
      img:
        "https://m.media-amazon.com/images/I/51+w3QHeyCL._AC_SX355_.jpg",
    },
    {
      id: 3,
      title: "Elmsley Count",
      link: "https://www.bilibili.com/video/BV1F34y167KU/",
      img:
        "https://i.ytimg.com/vi/nDj-XpxmN4Q/maxresdefault.jpg",
    },
    {
      id: 4,
      title: "The Matrix",
      link: "https://www.bilibili.com/video/BV1Sr4y1v7Qu/",
      img:
        "https://s24193.pcdn.co/wp-content/uploads/2017/06/entity-magic--1320x720.jpg",
    },
    {
      id: 5,
      title: "Happy New Year",
      link: "https://www.bilibili.com/video/BV19S4y1y7Na/",
      img:
        "https://vinc.gumlet.io/gallery/blog/Easy-to-do-card-magic-tricks-637181767004663922.jpg",
    },
  ];
  
  export const coinPortfolio = [
    {
      id: 1,
      title: "Coin Matrix",
      link: "https://www.bilibili.com/video/BV1Nr4y1U7qw/",
      img:
        "https://i.ytimg.com/vi/Y5hXMFM1s1M/maxresdefault.jpg",
    },
  ];
  
  export const otherPortfolio = [
  ];
  
